import dayjs from "dayjs";
import store from "@/store";

/**
 * 获取水印
 * @param width
 * @param height
 */
export const getWatermark = (
  width: number,
  height: number,
  watermark = {
    watermarkTransparency: 0,
  }
) => {
  const time = dayjs().format("YYYY-MM-DD HH:mm:ss");
  let text = `${localStorage.userName} +${store.getters.getAreaCode} ${store.getters.getUserPhone} ${time}`;

  const createCanvas = document.createElement("canvas");
  createCanvas.width = width;
  createCanvas.height = height;
  let ctx = createCanvas.getContext("2d") as CanvasRenderingContext2D;
  ctx.font = "normal 100 40px serif";
  // 设置颜色
  ctx.fillStyle = `rgba(170, 170, 170, ${
    (100 - watermark.watermarkTransparency) / 100
  })`;

  let txtWidth = ctx.measureText(text).width;
  ctx.translate(width / 2, height / 2);

  const degree =
    (Math.asin(width / Math.sqrt(width * width + height * height)) / Math.PI) *
    180;

  ctx.rotate((-(90 - degree) * Math.PI) / 180);
  ctx.fillText(text, 0 - txtWidth / 2, -30, 10000); /* centerX */
  // 设置水平对齐方式
  // 设置垂直对齐方式
  ctx.textBaseline = "middle";
  /*  var image = createCanvas.toDataURL("image/png"); */
  return createCanvas.toDataURL("image/png");
};

export const getCoNameWatermark = (
  width: number,
  height: number,
  watermark = {
    watermarkTransparency: 0,
  }
) => {
  const text = localStorage.coName;

  const createCanvas = document.createElement("canvas");
  createCanvas.width = width;
  createCanvas.height = height;

  let ctx = createCanvas.getContext("2d") as CanvasRenderingContext2D;
  ctx.font = "normal 100 40px serif";
  // 设置颜色
  ctx.fillStyle = `rgba(170, 170, 170, ${
    (100 - watermark.watermarkTransparency) / 100
  })`;

  let txtWidth = ctx.measureText(text).width;
  ctx.translate(width / 2, height / 2);

  const degree =
    (Math.asin(width / Math.sqrt(width * width + height * height)) / Math.PI) *
    180;

  ctx.rotate((-(90 - degree) * Math.PI) / 180);
  ctx.fillText(`${text}`, 0 - txtWidth / 2, 30, 10000);
  // 设置水平对齐方式
  // 设置垂直对齐方式
  ctx.textBaseline = "middle";
  /*  var image = createCanvas.toDataURL("image/png"); */
  return createCanvas.toDataURL("image/png");
};
